import { IContainer, injectContainer } from './container';

export interface IQueryURL {
    parse: (queryString: string) => {};
    assemble: (queryArgs: {}) => string;
}

const TYPES = {
    IQueryURL: Symbol.for('IQueryURL'),
};

export function injectQueryURL(container: IContainer = injectContainer()): IQueryURL {
    return container.get<IQueryURL>(TYPES.IQueryURL);
}

export function bindQueryURL(val: IQueryURL, container: IContainer = injectContainer()) {
    return container.bind<IQueryURL>(TYPES.IQueryURL, val);
}
